import React from 'react';
import { useReactFlow, ControlButton, Controls } from '@xyflow/react';
import { LuMaximize } from 'react-icons/lu';

interface MindmapControlsProps {
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}

/**
 * Custom controls component that replaces React Flow's default Controls
 * to provide a scaled fit view (60% of normal fit) for smaller node appearance.
 */
export function MindmapControls({ position = 'bottom-right' }: MindmapControlsProps) {
  const reactFlow = useReactFlow();

  const handleFitView = () => {
    try {
      reactFlow.fitView({ includeHiddenNodes: true, padding: 0.3, duration: 200 });
    } catch (error) {
      console.error('Error in fit view:', error);
    }
  };

  return (
    <Controls position={position} showFitView={false}>
      <ControlButton onClick={handleFitView} title='Fit view (scaled)'>
        <LuMaximize size={16} />
      </ControlButton>
    </Controls>
  );
}
